import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

import { IContext } from './types/context';
import { IStationModalData } from './types/stationModalData';

interface Props {
  children: React.ReactNode;
}

export const StationInfoContext = createContext({} as IContext);
export const useStationInfoContext = () => useContext(StationInfoContext);

const RouteProvider = (props: Props) => {
  const { children } = props;

  const [ stationModalData, setStationModalData ] = useState<IStationModalData>();
  const resetStationModalData = useCallback(() => {
    setStationModalData(undefined);
  }, [setStationModalData]);

  const value = useMemo(
    () => ({
      setStationModalData,
      stationModalData,
      resetStationModalData
    }),
    [
      setStationModalData,
      stationModalData,
      resetStationModalData
    ]
  );

  return (
    <StationInfoContext.Provider value={value}>{children}</StationInfoContext.Provider>
  );
};

export default RouteProvider;
